// @mui material components
import Grid from "@mui/material/Grid";

// Ajce Hostel App React components
import MDBox from "components/MDBox";

// Ajce Hostel App React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

// Data
import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

// Dashboard components
import Projects from "layouts/dashboard/components/Projects";
import OrdersOverview from "layouts/dashboard/components/OrdersOverview";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import Timeline from "./components/Timeline";
import { useEffect, useState } from "react";
import { getInOutCount } from "framework/students/summary";
import StudentsList from "layouts/studentsList";
import { StudentListTable } from "layouts/studentsList/components/studentListTable";
import { getAttendaceCount } from "framework/students/summary";

function Dashboard() {
  const { sales, tasks } = reportsLineChartData;
  const auth = getAuth();
  const navigate = useNavigate();
  const [statusCount, setStatusCount] = useState({ totalIn: -1, totalOut: -1 });
  const [attendanceCount, setAttendanceCount] = useState(0);

  useEffect(() => {
    (async () => {
      if (statusCount.totalIn === -1) {
        console.log("yesd");
        let count = await getInOutCount();
        setStatusCount(count);
      }
    })();
    (async () => {
      const count = await getAttendaceCount();
      setAttendanceCount(count);
    })();
  }, []);

  onAuthStateChanged(auth, (user) => {
    if (!user) {
      navigate("/authentication/sign-in");
    }
  });

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="groups"
                title="Attendance"
                count={attendanceCount}
                percentage={{
                  color: "success",
                  amount: "+55%", // NOTE: can be replaced with attendance % of present day fetched from db or we can completely remove it
                  label: "than lask week",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="call_received"
                title="In"
                count={statusCount.totalIn} // NOTE: Dummy value to be replaced with whatever fetched from firebase
                percentage={{
                  color: "success",
                  amount: "+3%",
                  label: "than last month",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="error"
                icon="arrow_outward"
                title="Out"
                count={statusCount.totalOut}
                percentage={{
                  color: "success",
                  amount: "+1%",
                  label: "than yesterday",
                }}
              />
            </MDBox>
          </Grid>
          {/* <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                icon="person_add"
                title="Followers"
                count="+91"
                percentage={{
                  color: "success",
                  amount: "",
                  label: "Just updated",
                }}
              />
            </MDBox>
          </Grid> */}
        </Grid>
        {/* <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsBarChart
                  color="info"
                  title="website views"
                  description="Last Campaign Performance"
                  date="campaign sent 2 days ago"
                  chart={reportsBarChartData}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="success"
                  title="daily sales"
                  description={
                    <>
                      (<strong>+15%</strong>) increase in today sales.
                    </>
                  }
                  date="updated 4 min ago"
                  chart={sales}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="dark"
                  title="completed tasks"
                  description="Last Campaign Performance"
                  date="just updated"
                  chart={tasks}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox> */}
        <MDBox>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={8}>
              <StudentListTable enableToolbar />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <Timeline
                inPercentage={(
                  (statusCount.totalIn * 100) /
                  (statusCount.totalIn + statusCount.totalOut)
                ).toFixed(2)}
                outPercentage={(
                  (statusCount.totalOut * 100) /
                  (statusCount.totalIn + statusCount.totalOut)
                ).toFixed(2)}
              />
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
